import React from "react";
import "./PlacedCandidates.css";
import { Link } from "react-router-dom";

import candidate1 from "../assets/placedCand1.png";
import candidate2 from "../assets/placedCand2.jpg";

const candidates = [
  {
    name: "Naveen",
    role: "React Native Developer",
    company: "EDUCASE Pvt Ltd",
    image: candidate1,
    story:
      "Joining AAPS was one of the most valuable decisions in my career journey. The training program provided me with in-depth knowledge of React Native, JavaScript, API integration, and mobile application development. The hands-on projects and continuous support from the trainers helped me strengthen both my technical skills and confidence. The placement team guided me through resume preparation, mock interviews, and technical rounds, which played a crucial role in my success. With consistent practice and the mentorship of AAPS, I was able to secure a position as a React Native Developer at EduCase Private Limited. I am extremely grateful to AAPS for providing the right guidance and opportunities to help me achieve this milestone.",
  },
  {
    name: "Dasari Keerthi",
    role: "UI/UX Designer",
    company: "Cixcent Technologies Pvt Ltd",
    image: candidate2,
    story:
      "My journey with AAPS has been truly transformational. The training program helped me build a strong foundation in UI/UX design principles, wireframing, prototyping, and modern design tools such as Figma and Adobe XD. The trainers provided practical insights and encouraged me to work on real-time projects, which significantly improved my creativity and problem-solving abilities. The placement support team conducted mock interviews and portfolio reviews that boosted my confidence and prepared me for the recruitment process. With the knowledge and guidance I received from AAPS, I successfully secured a role as a UI/UX Designer at Cixcent Technologies Private Limited. I sincerely thank AAPS for helping me turn my passion for design into a successful career.",
  },
];

const PlacedCandidates = () => {
  return (
    <div className="placed-page">
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span>/</span>
        <p>Placed Candidates</p>
      </div>

      <div className="placed-header">
        <h1>
          Our Successful <span>Candidates</span>
        </h1>
        <p>
          Celebrating the achievements of our students who transformed their
          careers with AAPS.
        </p>
      </div>

      <div className="candidates-container">
        {candidates.map((candidate, index) => (
          <div className="candidate-card" key={index}>
            <div className="candidate-image">
              <img src={candidate.image} alt={candidate.name} />
            </div>

            <div className="candidate-content">
              <h2>{candidate.name}</h2>
              <h3>
                {candidate.role} at <span>{candidate.company}</span>
              </h3>
              <p>{candidate.story}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlacedCandidates;
